const News = () => import(/* webpackChunkName: "News" */ "@/views/news/News");
const NewsList = () => import(/* webpackChunkName: "NewsList" */ "@/views/news/NewsList");
const NewsNew = () => import(/* webpackChunkName: "InfoNew" */ "@/views/news/NewsNew");

const newsRoutes = [
  {
    path: "news",
    name: "news",
    redirect: {
      name: "News List"
    },
    component: News,
    children: [
      {
        path: "list",
        name: "News List",
        component: NewsList
      },
      {
        path: "new",
        name: "News New",
        component: NewsNew,
        props: route => ({
          type: route.query.type
        })
      },
      {
        path: "edit/:id",
        name: "News Edit",
        component: NewsNew,
        props: route => ({
          id: route.params.id,
          selected: route.params.selected
        })
      }
    ]
  }
];

export default newsRoutes;